import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';
import { getContinentByCountry } from '../common/location';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";
import {hideModal} from "../common/activeModal";
import { removeSubRolesRequiringHasIVs, getSubRoles, SUB_ROLES } from '../account/role';
import {getSelectedLanguage} from "../common/localization";
import { fetchGetKey } from '../accreditation/certificate';

//- Actions

export const onRegisterOrgByAnchor = createAction(
    'FETCH_REGISTER_ORG_BY_ANCHOR',
    (language, data) => Api.registerOrgByAnchor(language, data),
    () => ({
        apiCall: true,
        onSuccess: onRegisterOrgByAnchorSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchRegisterOrgByAnchor = (data) => (dispatch, getState) => {
    dispatch(fetchSubmitForm());
    dispatch(onRegisterOrgByAnchor(getSelectedLanguage(getState()), data));
};

export const onRegisterOrgByAnchorSuccess = () => dispatch => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(hideModal());
};


export const fetchGetOrgPriceByAnchorFailed = createAction('FETCH_GET_ORG_PRICE_BY_ANCHOR_FAILED');
export const fetchGetOrgPriceByAnchorSuccess = createAction('FETCH_GET_ORG_PRICE_BY_ANCHOR_SUCCESS');
export const fetchGetOrgPriceByAnchor = createAction(
    'FETCH_GET_ORG_PRICE_BY_ANCHOR',
    (countryCode, organizationType) => Api.getPricingPresetByAnchor(countryCode, organizationType),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgPriceByAnchorSuccess,
        onFail: fetchGetOrgPriceByAnchorFailed,
        onForbidden: onForbidden
    })
);

export const fetchGetOrgFailed = createAction('FETCH_GET_ORG_FAILED');
export const fetchGetOrgSuccess = createAction('FETCH_GET_ORG_SUCCESS');
export const fetchGetOrg = createAction(
    'FETCH_GET_ORG',
    () => Api.getOrg(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgSuccess,
        onFail: fetchGetOrgFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetOrgForAppFailed = createAction('FETCH_GET_ORG_FOR_APP_FAILED');
export const fetchGetOrgForAppSuccess = createAction('FETCH_GET_ORG_FOR_APP_SUCCESS');
export const onFetchGetOrgForAppSuccess = (data) => (dispatch, getState) => {
    let hasIVs = data.hasIVs;
    if (!hasIVs) {
        dispatch(removeSubRolesRequiringHasIVs())
    }
    
    let subRoles = getSubRoles(getState());
    if (subRoles.includes(SUB_ROLES.INSERTER) /*&& check permissions*/) {        
        dispatch(fetchGetKey())
    }

    dispatch(fetchGetOrgForAppSuccess(data));
};

export const onGetOrgPriceByAnchor = () => (dispatch, getState) => {
    let data = getOrgData(getState());

    if (!_.isNil(data)) {
        dispatch(fetchGetOrgPriceByAnchor(data.address.countryCode, data.type))
    }
};

export const fetchGetOrgForApp = createAction(
    'FETCH_GET_ORG_FOR_APP',
    () => Api.getOrg(),
    () => ({
        apiCall: true,
        onSuccess: onFetchGetOrgForAppSuccess,
        onFail: fetchGetOrgForAppFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetOrgBalanceFailed = createAction('FETCH_GET_ORG_BALANCE_FAILED');
export const fetchGetOrgBalanceSuccess = createAction('FETCH_GET_ORG_BALANCE_SUCCESS');
export const fetchGetOrgBalance = createAction(
    'FETCH_GET_ORG_BALANCE',
    () => Api.getOrgBalance(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgBalanceSuccess,
        onFail: fetchGetOrgBalanceFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onEditOrgByAnchorSuccess = () => (dispatch) => {
    dispatch(fetchGetOrg());
    dispatch(fetchSubmitFormSuccess());
};

export const onEditOrgByAnchor = createAction(
    'FETCH_EDIT_ORG_BY_ANCHOR',
    data => Api.updateOrgByAnchor(data),
    () => ({
        apiCall: true,
        onSuccess: onEditOrgByAnchorSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchEditOrgByAnchor = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onEditOrgByAnchor(data));
};


export const fetchGetOperationAvailabilityFailed = createAction('FETCH_GET_OPERATION_AVAILABILITY_FAILED');
export const fetchGetOperationAvailabilitySuccess = createAction('FETCH_GET_OPERATION_AVAILABILITY_SUCCESS');
export const fetchGetOperationAvailability = createAction(
    'FETCH_GET_OPERATION_AVAILABILITY',
    () => Api.getOperationAvailability(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOperationAvailabilitySuccess,
        onFail: fetchGetOperationAvailabilityFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    error: null,
    fetching: false,
    success: false,
    data: null,
    balanceData: null,
    fetchingBalance: false,
    fetchingOrgForApp: false,
    pricingData: null,
    operationAvailability: null
};

//- Reducers
export default handleActions({

    FETCH_GET_ORG: (state) => {
        return {...state, error: null, fetching: true, success: false};
    },
    FETCH_GET_ORG_FAILED: (state, action) => {
        return {...state, error: action.payload, fetching: false, success: false};
    },
    FETCH_GET_ORG_SUCCESS: (state, action) => {
        return {...state, error: null, fetching: false, success: true, data: action.payload}
    },
    FETCH_GET_ORG_FOR_APP: (state) => {
        return {...state, error: null, fetchingOrgForApp: true};
    },
    FETCH_GET_ORG_FOR_APP_FAILED: (state, action) => {
        return {...state, error: action.payload, fetchingOrgForApp: false};
    },
    FETCH_GET_ORG_FOR_APP_SUCCESS: (state, action) => {
        return {...state, error: null, fetchingOrgForApp: false, data: action.payload}
    },
    FETCH_GET_ORG_BALANCE: (state) => {
        return {...state, error: null, fetchingBalance: true};
    },
    FETCH_GET_ORG_BALANCE_FAILED: (state, action) => {
        return {...state, balanceData: null, error: action.payload, fetchingBalance: false};
    },
    FETCH_GET_ORG_BALANCE_SUCCESS: (state, action) => {
        return {...state, balanceData: action.payload, error: null, fetchingBalance: false, success: true}
    },
    FETCH_GET_ORG_PRICE_BY_ANCHOR: (state) => {
        return {...state, pricingData: null, fetching: true, error: null, success: false};
    },
    FETCH_GET_ORG_PRICE_BY_ANCHOR_SUCCESS: (state, action) => {
        return {...state, pricingData: action.payload, fetching: false, error: null, success: true};
    },
    FETCH_GET_ORG_PRICE_BY_ANCHOR_FAILED: (state, action) => {
        return {...state, pricingData: null, fetching: false, error: action.payload, success: false};
    },
    FETCH_GET_OPERATION_AVAILABILITY_SUCCESS: (state, action) => {
        return {...state, operationAvailability: action.payload};
    },
    FETCH_GET_OPERATION_AVAILABILITY_FAILED: (state) => {
        return {...state, operationAvailability: null};
    }

}, initialState);

//- Selectors
export const getOrg = state => state.organization;

export const getOrgData = state => getOrg(state).data;

export const loadingOrg = state => getOrg(state).fetching;

export const loadingOrgForApp = state => getOrg(state).fetchingOrgForApp;

export const getEmailDomain = state => {
    if (_.isNil(getOrgData(state))) {
        return null;
    }

    return getOrgData(state).domain;
};

export const getOrgName = state => {
    if (_.isNil(getOrgData(state))) {
        return null;
    }

    return getOrgData(state).name;
};

export const getOrgCountryCode = state => {
    if (_.isNil(getOrgData(state)) || _.isNil(getOrgData(state).address)) {
        return null;
    }

    return getOrgData(state).address.countryCode;
};

export const getOrgBalance = state => getOrg(state).balanceData;

export const getOrgPrice = state => {
    let data = getOrgData(state);

    if (_.isNil(data)) {
        return null;
    }

    return {...data.pricing};
};

export const getOrgPermissions = state => {
    if (_.isNil(getOrgData(state))) {
        return null;
    }

    let data = getOrgData(state);
    return {
        hasIVs: data.hasIVs,
        verifiesIdentities: data.verifiesIdentities,
        providesMoocCertificates: data.providesMoocCertificates,
        validated: data.validated
    };
};

export const isAccreditationSigningRequired = state => {
    let data = getOrgData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.inserterSignatureRequired;
};

export const getOrgType = state => {
    if (_.isNil(getOrgData(state))) {
        return null;
    }

    return getOrgData(state).type;
};

export const getOrgSettings = state => {
    let data = getOrgData(state);

    if (_.isNil(data)){
        return null;
    }

    return {
        orgType: data.type,
        orgName: data.name,
        orgDomain: data.domain,
        orgVatNumber: data.vatNumber,
        companyCode: data.companyCode,
        orgContinent: getContinentByCountry(data.address.countryCode, state),
        orgCountry: data.address.countryCode,
        orgEmployeeCount: data.employeeCount,
        orgCity: data.address.city,
        orgPostal: data.address.postal,
        orgStreet: data.address.street,
        financialData: data.financialData
    }
};

export const isOrganizationValidated = state => {
    let data = getOrgData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.validated;
};

export const getOrgPricingData = state => getOrg(state).pricingData;

export const getConsentRequestFee = state => {
    let data = getOrgData(state);

    if (_.isNil(data) ||  _.isNil(data.pricing) || _.isNil(data.pricing.consentRequestFee)) {
        return null;
    }

    return data.pricing.consentRequestFee;
};

export const getPaidTillDate = state => {
    let data = getOrgData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.paidTill;
};

export const getOperationAvailability = state => getOrg(state).operationAvailability;

export const isOrgBava = state => getOrgData(state).bava;


// WEBPACK FOOTER //
// ./src/reducers/organization/organization.js